module.exports = __webpack_public_path__ + "static/img/man_glove_1.c6876b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/man_glove_1.png
// module id = B2Oi
// module chunks = 0